// extracted by mini-css-extract-plugin
module.exports = {"size_select":"SizeButtonGroup_size_select__3OBOX","selected":"SizeButtonGroup_selected__jmidt"};